import { Rule } from 'antd/es/form';
import TextArea from 'antd/es/input/TextArea';
import React from 'react';

import { formInputLength } from '../utils';
import { CardFormField } from './CardFormField';

interface IProps {
  name: string;
  fieldLabel: string;
  tooltip?: string;
  defaultValue?: string;
  required?: boolean;
  rows?: number;
  showCount?: boolean;
  maxLength?: number;
  onChange: (value) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
}

const CardFormTextArea: React.FC<IProps> = ({
  name,
  fieldLabel,
  tooltip,
  defaultValue = '',
  required = true,
  rows = 4,
  showCount = true,
  maxLength = 300,
  onChange,
  autoFocus = false,
  disabled,
  className = '',
  placeholder = '',
}) => {
  let customValidator;
  let customRules: Rule[] = [];
  if (maxLength) {
    customValidator = e => {
      return formInputLength(e.target.value, maxLength);
    };
    customRules.push({
      max: maxLength,
      message: `Limit of ${maxLength} characters exceeded`,
    });
  }

  return (
    <div
      className={`card-form-text-area-wrapper ${
        showCount ? 'text-area-show-count' : ''
      }`}
    >
      <CardFormField
        name={name}
        boldLabel={true}
        fieldLabel={fieldLabel}
        tooltip={tooltip}
        defaultValue={defaultValue}
        customValidator={customValidator}
        customRules={customRules}
        required={required}
      >
        <TextArea
          rows={rows}
          autoFocus={autoFocus}
          showCount={showCount}
          maxLength={maxLength}
          onChange={onChange}
          value={defaultValue}
          disabled={disabled}
          className={className}
          placeholder={placeholder}
        />
      </CardFormField>
    </div>
  );
};

export default CardFormTextArea;
